var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import * as fuzzysort from 'fuzzysort';
import { SearchableSelect } from '../SearchableSelect/SearchableSelect.js';
import { FormControlLayout } from './FormControlLayout.js';
import { extractLayoutProps } from './utils.js';
export const FormControlSearchableSelect = (_a) => {
    var { onChange, placeholder, value, options, onInputChange, loading = false, hideIcon = false, hideClearIcon = false } = _a, rest = __rest(_a, ["onChange", "placeholder", "value", "options", "onInputChange", "loading", "hideIcon", "hideClearIcon"]);
    const { layoutProps, inputProps } = extractLayoutProps(rest);
    const [query, setQuery] = useState();
    const isAsyncSearching = typeof onInputChange === 'function';
    const filteredOptions = !isAsyncSearching && query
        ? fuzzysort.go(query, options !== null && options !== void 0 ? options : [], { key: 'key' }).map(res => res.obj)
        : options;
    const chosenOption = options === null || options === void 0 ? void 0 : options.find(option => (option === null || option === void 0 ? void 0 : option.value) === value);
    return (React.createElement(FormControlLayout, Object.assign({}, layoutProps),
        React.createElement(SearchableSelect, Object.assign({}, inputProps, { options: filteredOptions !== null && filteredOptions !== void 0 ? filteredOptions : [], value: chosenOption, onChange: item => { var _a; return onChange((_a = item === null || item === void 0 ? void 0 : item.value) !== null && _a !== void 0 ? _a : ''); }, onInputChange: value => {
                if (isAsyncSearching) {
                    onInputChange(value);
                }
                else {
                    setQuery(value);
                }
            } }),
            React.createElement(SearchableSelect.Button, { hideClearIcon: hideClearIcon, hideIcon: hideIcon, placeholder: placeholder }, chosenOption === null || chosenOption === void 0 ? void 0 : chosenOption.text),
            React.createElement(SearchableSelect.Items, null, filteredOptions === null || filteredOptions === void 0 ? void 0 :
                filteredOptions.map(option => (React.createElement(SearchableSelect.Item, { key: option === null || option === void 0 ? void 0 : option.value, value: option === null || option === void 0 ? void 0 : option.value }, option === null || option === void 0 ? void 0 : option.text))),
                (filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) === 0 && (React.createElement(SearchableSelect.ItemsEmpty, null, "No results")),
                loading && (React.createElement(SearchableSelect.ItemsEmpty, null, "Loading..."))))));
};
//# sourceMappingURL=FormControlSearchableSelect.js.map